export { default } from "./NoteText"
